import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-tnc.magic.css.js';
import script from './keycloak-tnc.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-scrollable",attrs:{"part":"content-scrollable"}},[_c('magic-static-page-content',{attrs:{"slug":"keycloak-tnc"},on:{"contentLoad":_vm.onContentLoad}})],1),_vm._v(" "),(_vm.contentLoaded)?_c('div',{staticClass:"actions"},[_c('form',{ref:"accept-form",attrs:{"action":_vm.loginAction,"method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"version"},domProps:{"value":_vm.version}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"accept","value":"accept"}}),_vm._v(" "),_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","type":"submit"},domProps:{"innerHTML":_vm._s(_vm.$t('terms-updated.button'))},on:{"click":_vm.submitAccept}})],1),_vm._v(" "),_c('form',{ref:"reject-form",attrs:{"action":_vm.loginAction,"method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"version"},domProps:{"value":_vm.version}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"cancel","value":"cancel"}}),_vm._v(" "),_c('magic-ui-button',{attrs:{"wide":"","hollow":"","variant":"primary","type":"submit"},domProps:{"innerHTML":_vm._s(_vm.$t('terms-updated.decline'))},on:{"click":_vm.submitReject}})],1)]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e3b9e37a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-e3b9e37a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
